import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../contexts/ThemeContext';

export const ThemeToggle: React.FC = () => {
  const { resolvedTheme, setTheme } = useTheme();

  // Simple, unambiguous light <-> dark switch based on what's actually showing.
  const isDark = resolvedTheme === 'dark';
  const Current = isDark ? MoonIcon : SunIcon;

  return (
    <button
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className="dash-header__user-btn inline-flex items-center justify-center rounded-md p-2"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <Current className="h-5 w-5" />
    </button>
  );
};
